import {useState, useEffect} from 'react';
import "./NotificationComp.scss"
import ExpandCircleDownOutlinedIcon from '@mui/icons-material/ExpandCircleDownOutlined';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ModalActionBtn, { ModalBtnType } from '../../../CommonComponents/ModalButtons/ModalActionBtn/ModalActionBtn';
import { NotificationInterface } from '../../../../Models/Notification';
import { useNavigate } from 'react-router-dom';
import { NotificationActionType, NotificationActionTypes } from "../NotificationActionTypes";
import GGDialogueBox, { dialogueType } from "../../../UtilityComponents/GGDialogueBox/GGDialogueBox";
import { ErrorLogger } from '../../../../utils/Logger';

interface NotificationPropInterface {
  openPanel: boolean
  notificationData: NotificationInterface[]
}

const NotificationComp = (props: NotificationPropInterface) => {
  const navigate = useNavigate();
  const { openPanel, notificationData } = props;
  const [expanded, setExpanded] = useState<string>("none");
  const [popupState, setPopupState] = useState<{ open: boolean; title: string; message: string }>({
    open: false,
    title: "",
    message: "",
  });

  const handleDropdown = (target: any, id: string, boxID: string) => {
    if(expanded === id) setExpanded("none")
    else setExpanded(id)
    document.getElementById(boxID)?.classList.toggle('active')
  }

  const handleIconType = (iconType: string) => {
    if(iconType === "urgent") return <PriorityHighIcon className={`notificationCheckIcon ${iconType}`} />
    else if(iconType === "warning") return <WarningIcon className={`notificationCheckIcon ${iconType}`} />
    else if(iconType === "info") return <InfoIcon className={`notificationCheckIcon ${iconType}`} />
    else if(iconType === "success") return <CheckCircleIcon className={`notificationCheckIcon ${iconType}`} />
    return <></>
  }

  const mapNotificationToAction = (item: NotificationInterface): NotificationActionTypes => {
    switch (item.actionType) {
      case NotificationActionType.REDIRECT_TO_ABSOLUTE_URL:
        return { type: NotificationActionType.REDIRECT_TO_ABSOLUTE_URL, absoluteUrl: item.metadata.absoluteUrl };
      case NotificationActionType.REDIRECT_TO_RELATIVE_URL:
        return { type: NotificationActionType.REDIRECT_TO_RELATIVE_URL, relativeUrl: item.metadata.relativeUrl };
      case NotificationActionType.REDIRECT_TO_CHAT_CHANNEL:
        return { type: NotificationActionType.REDIRECT_TO_CHAT_CHANNEL, chatChannelId: item.metadata.chatChannelId };
      case NotificationActionType.SHOW_POPUP:
        return { type: NotificationActionType.SHOW_POPUP, title: item.metadata.title, message: item.metadata.message };
      case NotificationActionType.NONE:
      default:
        return { type: NotificationActionType.NONE };
    }
  };

  const notificationActionClickHandler = (action: NotificationActionTypes) => {
    switch (action.type) {
      case NotificationActionType.REDIRECT_TO_ABSOLUTE_URL:
        window.location.href = action.absoluteUrl;
        break;
      case NotificationActionType.REDIRECT_TO_RELATIVE_URL:
        navigate(action.relativeUrl);
        break;
      case NotificationActionType.REDIRECT_TO_CHAT_CHANNEL:
        navigate("/my-messages", { state: { channelId: action.chatChannelId } });
        break;
      case NotificationActionType.SHOW_POPUP:
        setPopupState({ open: true, title: action.title, message: action.message });
        break;
      case NotificationActionType.NONE:
        // No action needed
        break;
      default:
        ErrorLogger.log(`Unknown action type: ${(action as { type?: string }).type ?? String(action)}`, 'NotificationComp.notificationActionClickHandler');
    }
  };

  const NotificationMapper = () => (
    notificationData.map((item, index) => (
      <div className="notificationBox" id={`notificationBox_${item.id}`} key={item.id}>
        <div className="notificationHeader">
          { handleIconType(item.severity) }
          <p>{item.title}</p>
          <ExpandCircleDownOutlinedIcon className="notiExpandIcon" onClick={({target}) => handleDropdown(target, item.id, `notificationBox_${item.id}`)}/>
        </div>
        <div className={expanded === item.id ? "notificationDescription active" : "notificationDescription"}>
          <p>{item.message}</p>
          <ModalActionBtn
            text="Click Here"
            type={ModalBtnType.dark}
            callToAction={() => notificationActionClickHandler(mapNotificationToAction(item))}
          />
        </div>
      </div>
    ))
  )

  useEffect(() => {
    setExpanded("none")
    // eslint-disable-next-line
  }, [openPanel])

  return (
    <>
      <div className="notificationsWrapper">{NotificationMapper()}</div>
      <GGDialogueBox
        type={dialogueType.Info}
        isOpen={popupState.open}
        message={popupState.message}
        closeHandler={() => setPopupState({ ...popupState, open: false })}
        successHandler={() => setPopupState({ ...popupState, open: false })}
      />
    </>
  );
}

export default NotificationComp
